<template>
  <div class="source-wrap">
    <transition appear appear-to-class="animate__animated animate__fadeInLeft animate__delay-1s">
      <div class="left-content">
        <div class="data-location">
          <div class="title">
            <div class="text">
              数据位置
            </div>
            <div class="subText">
              DATA LOCATION
            </div>
          </div>
          <div id="dataLocation" class="content">
            <div class="location-item" :class="{active:activeItem ==='#location-item-1',correct:items['#location-item-1'].actived}" id="location-item-1" @click="selectItem('#location-item-1','消费力')">
              <div class="mask-layer"></div>
              <div class="icon">
                <img :src=" require('./../../../assets/image/datasource/money.png') " alt="">
              </div>
              <el-tooltip placement="right" effect="light">
                <div slot="content">
                  <div style="font-size: 14px;line-height: 26px">
                    <p>
                      ● 消费力是指网购客户的消费能力，一般从平台卖家产品定价密集度进行分析；
                    </p>
                    <p>
                      ● 调查分析该品类一个平台上价格的平均价格。
                    </p>
                    <p>
                      ● 调查单个SKU订单集中销售量和单个SKU的平均价格。
                    </p>
                  </div>
                </div>
                <div class="label-wrap">
                  <div class="label">
                    <span>
                      消费力
                    </span>
                    <svg t="1640571169345" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2093" width="24" height="24"><path d="M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z" fill="#1f6ee8" p-id="2094"></path><path d="M481.4336 714.8544a44.8 44.8 0 0 0-13.5168 31.744 45.056 45.056 0 0 0 13.5168 31.744 47.6672 47.6672 0 0 0 65.5872 0 44.8 44.8 0 0 0 13.4656-31.744 44.5952 44.5952 0 0 0-13.4656-31.744 47.9232 47.9232 0 0 0-65.5872 0z" fill="#FFFFFF" p-id="2095"></path><path d="M359.8848 405.76c0 15.6672 13.824 28.416 30.8736 28.416 16.9984 0 30.8224-12.8 30.8224-28.416 0-47.104 40.6528-83.968 92.672-83.968 50.944 0 92.5696 31.5392 92.5696 74.9056 0 43.3152-25.8048 62.5152-50.7904 85.504-34.0992 31.3344-72.704 58.1632-72.704 104.704v48.128c0 15.6672 13.8752 28.416 30.8736 28.416 16.9984 0 30.8736-12.6464 30.8736-28.416v-48.128c0-22.8864 27.7504-39.68 54.6304-64.5632 33.792-31.1296 68.8128-50.944 68.8128-125.7472 0-74.8544-61.696-136.704-154.3168-136.704-85.1456 0-154.3168 68.1984-154.3168 145.8688z" fill="#FFFFFF" p-id="2096"></path></svg>

                  </div>
                </div>
              </el-tooltip>
              <div class="icon-right">
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
            <div class="location-item" :class="{active:activeItem ==='#location-item-2',correct:items['#location-item-2'].actived}" id="location-item-2" @click="selectItem('#location-item-2','总销量')">
              <div class="icon">
                <img :src=" require('./../../../assets/image/datasource/chart.png') " alt="">
              </div>
              <el-tooltip placement="right" effect="light">
                <div slot="content">
                  <div style="font-size: 14px;line-height: 26px">
                    <p>
                      ● 总销量是指一个品类上架产品的销量总和；
                    </p>
                    <p>
                      ● 分析平台所有卖家一段时期的该品类销售总量；
                    </p>
                    <p>
                      ● 也可以分析单个SKU销量总；
                    </p>
                    <p>
                      ● 总销量高而卖家数量也多，说明该产品有销量但价格竞争激烈；
                    </p>
                    <p>
                      ● 总销量高而卖家数量少，有可能头部品牌卖家形成，综合其他要素进行判断。
                    </p>
                  </div>
            </div>
                <div class="label-wrap">
                  <div class="label">
                    <span>
                      总销量
                    </span>
                    <svg t="1640571169345" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2093" width="24" height="24"><path d="M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z" fill="#1f6ee8" p-id="2094"></path><path d="M481.4336 714.8544a44.8 44.8 0 0 0-13.5168 31.744 45.056 45.056 0 0 0 13.5168 31.744 47.6672 47.6672 0 0 0 65.5872 0 44.8 44.8 0 0 0 13.4656-31.744 44.5952 44.5952 0 0 0-13.4656-31.744 47.9232 47.9232 0 0 0-65.5872 0z" fill="#FFFFFF" p-id="2095"></path><path d="M359.8848 405.76c0 15.6672 13.824 28.416 30.8736 28.416 16.9984 0 30.8224-12.8 30.8224-28.416 0-47.104 40.6528-83.968 92.672-83.968 50.944 0 92.5696 31.5392 92.5696 74.9056 0 43.3152-25.8048 62.5152-50.7904 85.504-34.0992 31.3344-72.704 58.1632-72.704 104.704v48.128c0 15.6672 13.8752 28.416 30.8736 28.416 16.9984 0 30.8736-12.6464 30.8736-28.416v-48.128c0-22.8864 27.7504-39.68 54.6304-64.5632 33.792-31.1296 68.8128-50.944 68.8128-125.7472 0-74.8544-61.696-136.704-154.3168-136.704-85.1456 0-154.3168 68.1984-154.3168 145.8688z" fill="#FFFFFF" p-id="2096"></path></svg>
    
                  </div>
                </div>
              </el-tooltip>
              <div class="icon-right">
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
            <div class="location-item" :class="{active:activeItem ==='#location-item-3',correct:items['#location-item-3'].actived}" id="location-item-3" @click="selectItem('#location-item-3','卖家数量')">
              <div class="icon">
                <img :src=" require('./../../../assets/image/datasource/shop.png') " alt="">
              </div>
              <el-tooltip placement="right" effect="light">
                <div slot="content">
                  <div style="font-size: 14px;line-height: 26px">
                    <p>
                      ● 卖家数量是指调查一个产品上架卖家的总数量；
                    </p>
                    <p>
                      ● 卖家数量的多寡，可以判断该产品销量的热度；
                    </p>
                    <p>
                      ● 产品的集中上架时间，卖家数量、订单总销量几个维度综合，可以分析该产品热卖走势，培育潜力款。
                    </p>
                  </div>
                </div>
                <div class="label-wrap">
                  <div class="label">
                    <span>
                      卖家数量
                    </span>
                    <svg t="1640571169345" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2093" width="24" height="24"><path d="M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z" fill="#1f6ee8" p-id="2094"></path><path d="M481.4336 714.8544a44.8 44.8 0 0 0-13.5168 31.744 45.056 45.056 0 0 0 13.5168 31.744 47.6672 47.6672 0 0 0 65.5872 0 44.8 44.8 0 0 0 13.4656-31.744 44.5952 44.5952 0 0 0-13.4656-31.744 47.9232 47.9232 0 0 0-65.5872 0z" fill="#FFFFFF" p-id="2095"></path><path d="M359.8848 405.76c0 15.6672 13.824 28.416 30.8736 28.416 16.9984 0 30.8224-12.8 30.8224-28.416 0-47.104 40.6528-83.968 92.672-83.968 50.944 0 92.5696 31.5392 92.5696 74.9056 0 43.3152-25.8048 62.5152-50.7904 85.504-34.0992 31.3344-72.704 58.1632-72.704 104.704v48.128c0 15.6672 13.8752 28.416 30.8736 28.416 16.9984 0 30.8736-12.6464 30.8736-28.416v-48.128c0-22.8864 27.7504-39.68 54.6304-64.5632 33.792-31.1296 68.8128-50.944 68.8128-125.7472 0-74.8544-61.696-136.704-154.3168-136.704-85.1456 0-154.3168 68.1984-154.3168 145.8688z" fill="#FFFFFF" p-id="2096"></path></svg>
    
                  </div>
                </div>
              </el-tooltip>
              <div class="icon-right">
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
            <div class="location-item" :class="{active:activeItem ==='#location-item-4',correct:items['#location-item-4'].actived}" id="location-item-4" @click="selectItem('#location-item-4','评论数')">
              <div class="icon">
                <img :src=" require('./../../../assets/image/datasource/discuss.png') " alt="">
              </div>
              <el-tooltip placement="right" effect="light">
                <div slot="content">
                  <div style="font-size: 14px;line-height: 26px">
                    <p>
                      ● 评论数是指客户对已销售订单的评论/评价数量总和；
                    </p>
                    <p>
                      ● 通过卖家评论数量可以判断产品的热卖程度；
                    </p>
                    <p>
                      ● 根据客户评价内容进行产品的优化或更新；
                    </p>
                  </div>
                </div>
                <div class="label-wrap">
                  <div class="label">
                    <span>
                      评论数
                    </span>
                    <svg t="1640571169345" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2093" width="24" height="24"><path d="M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z" fill="#1f6ee8" p-id="2094"></path><path d="M481.4336 714.8544a44.8 44.8 0 0 0-13.5168 31.744 45.056 45.056 0 0 0 13.5168 31.744 47.6672 47.6672 0 0 0 65.5872 0 44.8 44.8 0 0 0 13.4656-31.744 44.5952 44.5952 0 0 0-13.4656-31.744 47.9232 47.9232 0 0 0-65.5872 0z" fill="#FFFFFF" p-id="2095"></path><path d="M359.8848 405.76c0 15.6672 13.824 28.416 30.8736 28.416 16.9984 0 30.8224-12.8 30.8224-28.416 0-47.104 40.6528-83.968 92.672-83.968 50.944 0 92.5696 31.5392 92.5696 74.9056 0 43.3152-25.8048 62.5152-50.7904 85.504-34.0992 31.3344-72.704 58.1632-72.704 104.704v48.128c0 15.6672 13.8752 28.416 30.8736 28.416 16.9984 0 30.8736-12.6464 30.8736-28.416v-48.128c0-22.8864 27.7504-39.68 54.6304-64.5632 33.792-31.1296 68.8128-50.944 68.8128-125.7472 0-74.8544-61.696-136.704-154.3168-136.704-85.1456 0-154.3168 68.1984-154.3168 145.8688z" fill="#FFFFFF" p-id="2096"></path></svg>
    
                  </div>
                </div>
              </el-tooltip>
              <div class="icon-right">
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
          </div>
          <div class="foot">
            <div class="metrics-select">
              <el-checkbox-group v-model="selectedMetrics" class="metrics-group" size="small">
                <el-checkbox label="总消费力计算"></el-checkbox>
                <el-checkbox label="总销量计算"></el-checkbox>
                <el-checkbox label="总卖家数量统计"></el-checkbox>
                <el-checkbox label="总评论数统计"></el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="submit-btn" id="submitBtn">
              <button @click="toNextRouter($event)">
                <div class="text">
                  生成数据
                </div>
                <div class="subText">
                  Generating data
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition appear appear-to-class="animate__animated animate__fadeInRight animate__delay-1s">
      <div class="right-content">
        <Shopee
            :items="items"
            @changeItems="changeItems"
            :activeItem="activeItem"
            @driverNext="moveNext"
            :DriverInstance="DriverInstance">
        </Shopee>
      </div>
    </transition>
    <StepDialog v-if="stepDialogStatus.show" :status="stepDialogStatus" @close="close"></StepDialog>
  </div>
</template>

<script>
  import Shopee from './shopee'
  import Driver from 'driver.js'
  import StepDialog from "../../../components/stepDialog";
  
  export default {
    components: {
      Shopee,
      StepDialog
    },
    data() {
      return {
        activeItem: '',
        selectedMetrics: [],
        items: {
          '#location-item-1': {
            name: '消费力',
            icon: 'money.png',
            link: '',
            color: 'red',
            isActive: '',
            actived: '',
            errorCount: 0
          },
          '#location-item-2': {
            name: '总销量',
            icon: 'chart.png',
            link: '',
            color: 'blue',
            isActive: '',
            actived: '',
            errorCount: 0
          },
          '#location-item-3': {
            name: '卖家数量',
            icon: 'shop.png',
            link: '',
            color: 'black',
            isActive: '',
            actived: '',
            errorCount: 0
          },
          '#location-item-4': {
            name: '评论数',
            icon: 'discuss.png',
            link: '',
            color: '#00bcd4',
            isActive: '',
            actived: '',
            errorCount: 0
          },
        },
        DriverInstance: null,
        stepDialogStatus:{
          show:false,
          in:false,
          start:1,
          end:3,
          page:'source'
        }
      }
    },
    created() {
      if (!this.$route.query.id) {
        this.$axios.post('/student/experiment/create', {}).then(res => {
          if (res.succeed) {
            this.$router.push({query: Object.assign(this.$route.query,{id:this.$route.query.id})})
          }
        })
      }
      if(!localStorage.getItem('source')){
        setTimeout(()=>{
          this.stepDialogStatus.show = true
          this.stepDialogStatus.in = true
        },2000)
      }
      
    },
    mounted() {
      this.DriverInstance = new Driver({
        closeBtnText: '关闭',
      })
    },
    beforeRouteLeave(to, from, next) {
      if (this.DriverInstance) {
        this.DriverInstance.reset()
      }
      next()
    },
    watch:{
      'stepDialogStatus.show':function (newv) {
        if(newv){
          document.body.style.overflow = 'hidden'
        }else {
          document.body.style.overflow = 'initial'
        }
      }
    },
    methods: {
      close(){
        this.stepDialogStatus.in = false
        setTimeout(()=>{
          this.stepDialogStatus.show = false
        },1000)
      },
      changeItems(obj) {
        Object.assign(this.items, obj)
      },
      selectItem(id, label) {
        this.activeItem = id
        this.items[id].isActive = true
        setTimeout(() => {
          this.DriverInstance.highlight({
            element: id
          })
          this.DriverInstance.highlight({
            element: '#shopeeContainer',
            popover: {
              className: 'hint',
              title: `<em>请在Shopee平台上找出<span style="color: red">${label}</span>的数据位置</em>`,
            }
          });
        })
      },
      stepStart() {
        if (!localStorage.getItem('DataSource1')) {
          this.DriverInstance = this.Driver('DataSource1')
          setTimeout(() => {
            this.DriverInstance.start()
          }, 2500)
        }
      },
      selectData(e, index) {
        if (this.DriverInstance?.isActivated) {
          document.querySelector('.el-scrollbar__wrap ').scrollTop = 200
          this.DriverInstance.moveNext()
        }
        this.activeIndex.indexOf(index) > -1 ? this.activeIndex.splice(this.activeIndex.indexOf(index), 1) : this.activeIndex.push(index)
        switch (index) {
          case 0:
            document.querySelector('.el-scrollbar__wrap').scrollTop = 200
            break;
          case 1:
            document.querySelector('.el-scrollbar__wrap').scrollTop = 0
            break;
          case 2:
            document.querySelector('.el-scrollbar__wrap').scrollTop = 0
            break;
          case 3:
            document.querySelector('.el-scrollbar__wrap').scrollTop = 0
            break;
        }
      },
      moveNext() {
        if (this.DriverInstance?.isActivated) {
          this.DriverInstance.moveNext()
        }
      },
      toNextRouter() {
        this.$router.push({path: '/data/generation', query: Object.assign(this.$route.query,{id:this.$route.query.id})})
      }
    }
    
  }
</script>

<style scoped lang="scss">
  @mixin title {
    padding: 30px 30px 0 30px;
    margin-bottom: 10px;
    .text {
      font-size: 26px;
      font-weight: bold;
      line-height: 33px;
    }
    .subText {
      font-size: 12px;
      font-weight: 400;
      line-height: 15px;
      color: #999999;
    }
  }
  
  .source-wrap {
    display: flex;
    
    .left-content {
      width: 400px;
      min-width: 360px;
      height: 722px;
      margin-right: 40px;
      background: #FFFFFF;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      opacity: 1;
      border-radius: 12px;
      
      .data-location {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        
        .title {
          @include title;
          margin-bottom: 10px;
        }
        
        .content {
          flex-grow: 1;
          
          .location-item {
            cursor: pointer;
            display: flex;
            align-items: center;
            height: 108px;
            position: relative;
            padding-left: 38px;
            transition: background 0.5s linear;
            border-bottom: 1px solid #edeef2;
            
            &.correct:after {
              content: '';
              width: 30px;
              height: 30px;
              position: absolute;
              left: 0;
              top: 0;
              background: url("./../../../assets/image/dagou1.png") -2px -2px;
              background-size: 100% 100%;
            }
            &:first-child {
              border-top: 1px solid #edeef2;
            }
            &:last-child {
              border-bottom: none;
            }
            
            &:hover {
              transition: background 0.5s linear;
              background: #F7F7F7;
            }
            
            &.active {
              background: #F1F1F1;
              
              &:before {
                content: '';
                position: absolute;
                left: 0;
                height: 100%;
                width: 6px;
                background: #1f7ef4;
              }
            }
            
            
            
            .icon {
              width: 68px;
              height: 68px;
              margin-right: 24px;
              background: linear-gradient(140deg, #70A0EB 0%, #005BE7 100%);
              box-shadow: 0px 3px 6px rgba(0, 91, 231, 0.3);
              border-radius: 50%;
              text-align: center;
              display: flex;
              justify-content: center;
              align-items: center;
              
              img {
                display: block;
              }
            }
            
            .label-wrap {
              display: flex;
              justify-content: center;
              font-size: 22px;
              font-weight: 400;
              line-height: 28px;
              color: #999999;
              flex: 1;
              border-radius: 6px;
              transition: box-shadow 0.3s linear;
  
              .label {
                display: flex;
                align-items: center;
                span {
                  display: inline-block;
                  min-width: 88px;
                }
                svg {
                  margin-left: 6px;
                  width: 24px;
                  height: 24px;
                }
              }
              
            }
            
            .icon-right {
              margin: 0 24px;
              
              i {
                color: #B6B6B6;
                font-size: 24px;
                font-weight: 600;
              }
            }
            
            .marking {
              width: 70px;
              height: 34px;
              border-radius: 10px;
              line-height: 34px;
              text-align: center;
              font-weight: bold;
              font-size: 20px;
            }
            
            @keyframes infoWrapMove {
              0% {
                z-index: 1;
              }
              100% {
                left: 0;
                right: 0;
                bottom: 0;
                top: 0;
                margin: auto;
                z-index: 1;
              }
            }
            
            .info-wrap {
              position: fixed;
              left: 0;
              right: 0;
              bottom: 0;
              top: 0;
              margin: auto;
              z-index: 3;
              width: 200px;
              height: 100px;
              background: #FFFFFF;
              border-radius: 10px;
              box-shadow: 0 0 10px #000000;
            }
          }
          
        }
        
        .foot {
          padding: 0 30px 30px 30px;
          .metrics-select {
            margin-bottom: 12px;
            .metrics-group {
              display: flex;
              flex-wrap: wrap;
              gap: 8px 16px;
            }
          }
          
          .submit-btn {
            button {
              width: 100%;
              height: 64px;
              background: linear-gradient(90deg, #70A0EB 0%, #005BE7 100%);
              box-shadow: 0px 3px 6px rgba(0, 91, 231, 0.3);
              opacity: 1;
              border-radius: 60px;
              
              .text {
                font-size: 22px;
                font-family: Microsoft YaHei UI, serif;
                font-weight: 400;
                line-height: 26px;
                color: #FFFFFF;
              }
              
              .subText {
                font-size: 10px;
                font-weight: 400;
                line-height: 14px;
                color: #FFFFFF;
              }
            }
          }
        }
      }
    }
    
    .right-content {
      min-width: 990px;
      flex-grow: 1;
      flex-shrink: 1;
      height: 722px;
      background: #FFFFFF;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      border-radius: 12px;
      display: flex;
      justify-content: center;
      overflow: hidden;
      
    }
  }
  
  
  
  .info-wrap {
    width: 800px;
    height: 600px;
    background: #FFFFFF;
    position: absolute;
    left: -1000px;
    top: 0;
    z-index: 3;
  }


</style>
